<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="">
            <div>
              <div class="card top-draft">
                <div
                  class="col-lg-12 list-header mg-top-1 pad-header-bg clearfix"
                >
                  <div class="header-item-fix">
                    <b-form-input
                      size="sm"
                      type="text"
                      v-model="pageParams.contentKeyword"
                      placeholder="请输入搜索内容"
                      @keyup.enter.native="search"
                    ></b-form-input>
                    <b-button size="sm" variant="primary" @click="search()">
                      <i
                        class="bx bx-search-alt-2 font-size-16 align-middle"
                      ></i>
                      搜索
                    </b-button>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="resetParams()"
                    >
                      <i class="bx bx-revision font-size-16 align-middle"></i>
                      重置
                    </b-button>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="table-responsive" v-loading="tableLoading">
                    <table
                      class="table table-nowrap table-centered table-striped align-middle"
                    >
                      <thead>
                        <tr>
                          <th scope="col" style="width: 70px;">
                            <b-form-checkbox
                              @change="checkedAll"
                              v-model="indeterminate"
                              checked
                              plain
                            ></b-form-checkbox>
                          </th>
                          <th scope="col" style="width: 70px;">ID</th>
                          <th scope="col">评论内容</th>
                          <th scope="col">评论附件</th>
                          <th scope="col">所在内容</th>
                          <th scope="col">内容类型</th>
                          <th scope="col">作者</th>
                          <th scope="col">点赞</th>
                          <th scope="col">评论时间</th>
                          <th scope="col">操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in items" :key="item.id">
                          <td>
                            <b-form-checkbox
                              v-model="choiceListIds"
                              :value="item.id"
                              checked
                              plain
                            ></b-form-checkbox>
                          </td>
                          <td>{{ item.id }}</td>
                          <td class="w-200 white-inherit">
                            {{ item.message }}
                          </td>
                          <td>
                            <img
                              v-if="item.attachmentDtoList.length"
                              class="w-3-rem"
                              :src="`${item.attachmentDtoList[0].image}`"
                              alt
                            />
                            <img
                              v-if="!item.attachmentDtoList.length"
                              class="w-3-rem"
                              src="@/assets/images/image-null.jpg"
                              alt=""
                            />
                          </td>
                          <td class="w-200 white-inherit">
                            {{ item.sourceTitle || "--" }}
                          </td>
                          <td>{{ item.contentType || "--" }}</td>
                          <td>{{ item.userName || "--" }}</td>
                          <td>{{ item.likeNum || "0" }}</td>
                          <td>{{ item.createdAt || "--" }}</td>
                          <td>
                            <button
                              type="button"
                              class="btn-sm btn btn-primary m-r-10"
                              @click="toDetail(item)"
                              v-if="power['编辑']"
                            >
                              编辑
                            </button>
                            <button
                              type="button"
                              class="btn-sm btn btn-primary m-r-10"
                              @click="toStorage(item)"
                              v-if="power['添加']"
                            >
                              入库
                            </button>
                            <button
                              type="button"
                              class="btn-sm btn btn-danger"
                              @click="remove(item)"
                              v-if="power['移除']"
                            >
                              移除
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-if="!items || !items[0]" class="xb-table-noData">
                      <span v-if="!tableLoading && !items[0]">暂无数据</span>
                    </div>
                  </div>
                  <!-- :isBatch 如果有批量操作就传这个参数 没有就不传  
                  batchs 批量操作的列表 
                  pageCallback 分页组件的回调方法 -->
                  <pagination
                    class="bath_r_20"
                    :isBatch="true"
                    :batchs="batchs"
                    :total="pageTotal"
                    :pageSize="pageParams.pageSize"
                    :page.sync="pageParams.page"
                    @pageCallback="pageCallback"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <detail @pageCallback="pageCallback" ref="detail"></detail>
      <putStorage @pageCallback="pageCallback" ref="storage"></putStorage>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main.vue";
import Vue from "vue";
import Swal from "sweetalert2";
import pagination from "@/components/pagination/pagination.vue";
import content from "@/server/api/comments";
import detail from "./detail";
import putStorage from "./putStorage";
import { changeList } from "@/util/fun.js";

/**
 * Contacts-list component
 */
export default {
  components: {
    Layout,
    pagination,
    detail,
    putStorage,
  },

  data() {
    return {
      options: [
        { value: "all", label: "全部" },
        { value: "hot", label: "热评" },
      ],
      value: "all",
      power: "",
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 30,
        contentKeyword: "",
        mediaId: "",
        commentType: 0, //1运营，0用户，2帖子
      },
      items: [],
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        // { text: "移除", value: "1" },
        // { text: "入库", value: "2" },
      ],
      pageTotal: 0,
      tableLoading: false,
    };
  },

  watch: {
    value: function() {
      if (this.value == "all") {
        this.getList(0);
      }
      if (this.value == "hot") {
        this.getList(1);
      }
    },
    choiceListIds: function() {
      if (
        this.choiceListIds.length == this.allListIds.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  mounted() {
    this.pageParams.mediaId = JSON.parse(localStorage.chosedMedia).id;
    this.getList(0);
    this.power = this.utils.currentPower("创作平台-圈子评论管理");
    if (this.power["移除"]) {
      this.batchs.push({ text: "移除", value: "1" });
    }
    if (this.power["添加"]) {
      this.batchs.push({ text: "入库", value: "2" });
    }
    // this.batchs = this.utils.currentBatchs(this.batchs, this.power)
  },

  created() {},

  methods: {
    getList(isHot) {
      if (isHot !== false) {
        this.tableLoading = true;
        this.items = [];
      }
      let params = this.another(this.pageParams);
      this.cleanObj(params);
      this.choiceListIds = [];
      content.list(params).then((resp) => {
        if (resp.code == 0 && resp.data) {
          this.tableLoading = false;
          if (resp.data.items) {
            if (isHot == 1) {
              this.items = resp.data.items.filter((val) => {
                return val.hotState == 1;
              });
            } else {
              this.items = resp.data.items;
            }
            this.pageTotal = resp.data.total;
          }
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        if (obj.ps == 100) {
          this.pageParams.pageSize = 100;
          this.getList();
        } else if (obj.ps == 50) {
          this.pageParams.pageSize = 50;
          this.getList();
        } else {
          this.pageParams.pageSize = 30;
          this.getList();
        }
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "comments") {
        console.log("修改评论", obj.item);
        let item = obj.item;
        this.items = this.items.map((tr) => {
          if (tr.id == item.id) {
            return { ...tr, ...item };
          } else {
            return tr;
          }
        });
      }
      if (obj.code === "storage") {
        // this.getList();
      }
      if (obj.code === "batch") {
        //处理批量操作
        console.log(this.choiceListIds, "批量的id");
        if (obj.batch == 1) {
          if (this.choiceListIds.length) {
            //点击删除的处理方法
            this.remove();
          } else {
            Vue.swal("请选择要移除的内容");
            return;
          }
        }
        if (obj.batch == 2) {
          if (this.choiceListIds.length) {
            //点击导入的处理方法
            this.$refs.storage.showModel(this.choiceListIds, "isBatch");
          } else {
            Vue.swal("请选择要导入的内容");
            return;
          }
        }
      }
    },

    //去编辑
    toDetail(item) {
      this.$refs.detail.showModel(item);
    },

    toStorage(item) {
      this.$refs.storage.showModel(item);
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.contentKeyword = "";
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.allListIds;
      } else {
        this.choiceListIds = [];
      }
    },

    batchHide() {
      Swal.fire({
        title: "确定隐藏?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "隐藏",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.ids = this.choiceListIds;
          content.hide(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "隐藏成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    batchShow() {
      Swal.fire({
        title: "确定显示?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "显示",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.ids = this.choiceListIds;
          content.show(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "显示成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    batchRevert() {
      Swal.fire({
        title: "确定撤稿?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.ids = this.choiceListIds;
          content.revert(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "撤稿成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          content.remove(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              // this.getList(); 删除数据时不调用列表接口,直接从列表删除对应内容
              if (this.items.length == params.ids.length) {
                this.getList();
              } else {
                this.pageTotal -= params.ids.length;
                this.items = changeList("delete", this.items, params.ids, "id");
              }
              this.choiceListIds = [];
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },
  },
};
</script>
<style>
.a {
  margin-right: 30px;
}
</style>
